/**
 * Truncate banner text if taller than threshold and add Read more/Read less toggle
 */

class BannerTextHeightCompare {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }

    window.addEventListener('load', () => this.compareHeights());

    window.addEventListener('resize', () => {
      setTimeout(() => this.compareHeights(), 250);
    });
  }

  setup() {
    this.bindButtons();
    this.compareHeights();
  }

  bindButtons() {
    document.querySelectorAll('[data-banner-text-accordion]').forEach((textElement) => {
      const btn = textElement.querySelector('.banner__text-toggle');
      const labelEl = btn && btn.querySelector('.banner__text-toggle-label');

      if (!btn) return;

      btn.addEventListener('click', () => {
        const isExpanded = textElement.classList.contains('banner__text--expanded');
        const readMore = labelEl ? (labelEl.dataset.readMore || 'Read more') : 'Read more';
        const readLess = labelEl ? (labelEl.dataset.readLess || 'Read less') : 'Read less';

        if (isExpanded) {
          textElement.classList.remove('banner__text--expanded');
          if (labelEl) labelEl.textContent = readMore;
          btn.querySelector('.icon').style.transform = '';
        } else {
          textElement.classList.add('banner__text--expanded');
          if (labelEl) labelEl.textContent = readLess;
          btn.querySelector('.icon').style.transform = 'rotate(180deg)';
        }
      });
    });
  }

  compareHeights() {
    document.querySelectorAll('[data-banner-text-accordion]').forEach((textElement) => {
      const initialText = textElement.querySelector('.banner__text-initial');
      const toggleWrap = textElement.querySelector('.banner__text-toggle-wrap');

      if (!initialText || !toggleWrap) return;

      // Temporarily remove truncation to measure full height
      textElement.classList.remove('banner__text--truncated');
      const fullHeight = initialText.offsetHeight;

      // Threshold: 10rem (160px)
      const threshold = 10 * 16;

      if (fullHeight > threshold) {
        textElement.classList.add('banner__text--truncated');
        toggleWrap.style.display = '';
      } else {
        textElement.classList.remove('banner__text--truncated', 'banner__text--expanded');
        toggleWrap.style.display = 'none';
      }
    });
  }
}

new BannerTextHeightCompare();
